import(/* webpackMode: "eager" */ "/vercel/path0/app/product/new/page.tsx");
